<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>pending_actions</mat-icon>
      <ng-container *ngIf="selectedPrNumber !== null">PR #{{ selectedPrNumber }} Files</ng-container>
      <ng-container *ngIf="selectedPrNumber === null">{{ notebookViewMode === 'pending' ? 'Pending Files' : 'All Notebooks' }}</ng-container>
      ({{ getDisplayedNotebooks().length }})
    </h2>
    <div class="notebook-view-toggle">
      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="pr-select-field">
        <mat-label>Filter by PR</mat-label>
        <mat-select [ngModel]="selectedPrNumber" (ngModelChange)="onPrSelected($event)" >
          <mat-option [value]="null">— No PR filter —</mat-option>
          <mat-option *ngFor="let pr of pullRequests" [value]="pr.number">
            #{{ pr.number }} {{ pr.title }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button
        mat-stroked-button
        [color]="notebookViewMode === 'pending' && selectedPrNumber === null ? 'primary' : ''"
        (click)="setNotebookViewMode('pending')"
        class="toggle-btn">
        Pending Only
      </button>
      <button
        mat-stroked-button
        [color]="notebookViewMode === 'all' && selectedPrNumber === null ? 'primary' : ''"
        (click)="setNotebookViewMode('all')"
        class="toggle-btn">
        Show All ({{ githubFiles.length }})
      </button>
      <button mat-stroked-button color="primary" (click)="refreshAll()" [disabled]="isActionBusy(refreshActionKey()) || loading">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </div>
  </div>

  <div class="loading-overlay" *ngIf="githubLoading || loading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="pending-files-container" *ngIf="getDisplayedNotebooks().length > 0 && !githubLoading && !loading">
    <p class="pending-subtitle" *ngIf="selectedPrNumber !== null">
      .ipynb files added or changed in PR #{{ selectedPrNumber }}.
    </p>
    <p class="pending-subtitle" *ngIf="selectedPrNumber === null && notebookViewMode === 'pending'">
      The following .ipynb files from the jupyter-demos repository are not yet added to the database.
    </p>
    <p class="pending-subtitle" *ngIf="selectedPrNumber === null && notebookViewMode === 'all'">
      All .ipynb files available in the jupyter-demos repository on the main branch.
    </p>
    <mat-form-field class="search-field" appearance="outline">
      <mat-label>Search files...</mat-label>
      <input matInput [(ngModel)]="pendingFilesSearchTerm" placeholder="Type filename or path">
      <button mat-icon-button matSuffix *ngIf="pendingFilesSearchTerm" (click)="pendingFilesSearchTerm = ''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <div class="pending-files-list">
      <div class="pending-file-item" *ngFor="let file of getPaginatedItems('pendingFiles', getDisplayedNotebooks())">
        <span class="file-path">{{ file.path }}</span>
        <span class="file-name">{{ file.name }}</span>
        <button mat-stroked-button color="primary" class="quick-add-btn" type="button"
          (click)="openQuickAdd(file)">
          Quick Add
        </button>
      </div>
    </div>

    <div class="pagination-row" *ngIf="getDisplayedNotebooks().length > 0">
      <button mat-stroked-button type="button" (click)="goToPreviousPage('pendingFiles')" [disabled]="getCurrentPage('pendingFiles') === 1">Previous</button>
      <span>Page {{ getCurrentPage('pendingFiles') }} of {{ getTotalPages('pendingFiles', getDisplayedNotebooks().length) }}</span>
      <button mat-stroked-button type="button" (click)="goToNextPage('pendingFiles', getDisplayedNotebooks().length)" [disabled]="getCurrentPage('pendingFiles') >= getTotalPages('pendingFiles', getDisplayedNotebooks().length)">Next</button>
    </div>
  </div>
  <div class="empty-state" *ngIf="getDisplayedNotebooks().length === 0 && !githubLoading && !loading">
    <mat-icon>check_circle</mat-icon>
    <p *ngIf="selectedPrNumber !== null">No .ipynb files found in this PR.</p>
    <p *ngIf="selectedPrNumber === null && notebookViewMode === 'pending'">All jupyter-demos .ipynb files are synced!</p>
    <p *ngIf="selectedPrNumber === null && notebookViewMode === 'all'">No notebooks found.</p>
  </div>
</div>

<div class="modal-backdrop" *ngIf="activeModal">
  <div class="modal-card mat-elevation-z8">
    <div class="modal-header">
      <h3 *ngIf="activeModal === 'quick-add'"><span class="entity-id">{{ quickAddFile?.name }}</span></h3>
      <button mat-icon-button type="button" (click)="closeModal()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="modal-body" *ngIf="activeModal === 'quick-add'">
      <!-- File preview -->
      <div class="quick-add-file-info">
        <span class="quick-add-path-label">Path:</span>
        <code>{{ quickAddFile?.path }}</code>
      </div>

      <!-- Label + Type -->
      <div class="form-row material-grid">
        <mat-form-field appearance="outline">
          <mat-label>File Type</mat-label>
          <mat-select [(ngModel)]="quickAddFileType">
            <mat-option value="notebook">notebook</mat-option>
            <mat-option value="nbviewer">nbviewer</mat-option>
            <mat-option value="web">Web</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Label</mat-label>
          <mat-select [(ngModel)]="quickAddLabel">
            <mat-option value="SQL Version">SQL Version</mat-option>
            <mat-option value="Information">Information</mat-option>
            <mat-option value="Python Version">Python Version</mat-option>
            <mat-option value="Python-SQL Version">Python-SQL Version</mat-option>
            <mat-option value="support2">support2</mat-option>
            <mat-option value="Video">Video</mat-option>
            <mat-option value="Read Only Python-SQL">Read Only Python-SQL</mat-option>
            <mat-option value="R Version">R Version</mat-option>
            <mat-option value="Read Only SQL">Read Only SQL</mat-option>
            <mat-option value="support1">support1</mat-option>
            <mat-option value="None">None</mat-option>
            <mat-option value="Read Only Python">Read Only Python</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Mode toggle -->
      <div class="quick-add-mode-toggle">
        <button mat-stroked-button type="button"
          [color]="quickAddMode === 'existing' ? 'primary' : ''"
          (click)="quickAddMode = 'existing'">Add to Existing Demo</button>
        <button mat-stroked-button type="button"
          [color]="quickAddMode === 'new' ? 'primary' : ''"
          (click)="quickAddMode = 'new'">Create New Demo</button>
      </div>

      <!-- Existing demo search -->
      <div *ngIf="quickAddMode === 'existing'">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Search demos</mat-label>
          <input matInput [(ngModel)]="quickAddDemoSearch" placeholder="Type to filter..." [matAutocomplete]="quickAddDemoAuto" />
          <mat-autocomplete #quickAddDemoAuto="matAutocomplete" [displayWith]="displayDemoTitle" (optionSelected)="selectDemoForQuickAdd($event.option.value)">
            <mat-option *ngFor="let d of filteredDemosForQuickAdd()" [value]="d">{{ d.demo_title }} <span class="entity-id">ID: {{ d.id }}</span></mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div class="quick-add-selected" *ngIf="quickAddSelectedDemoId">
          Selected: <strong>{{ quickAddDemoSearch }}</strong> (ID {{ quickAddSelectedDemoId }})
        </div>
      </div>

      <!-- New demo form -->
      <div *ngIf="quickAddMode === 'new'">
        <div class="form-row material-grid">
          <mat-form-field appearance="outline">
            <mat-label>New Demo Title</mat-label>
            <input matInput [(ngModel)]="quickAddNewDemoTitle" />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Demo Type</mat-label>
            <mat-select [(ngModel)]="quickAddNewDemoType">
              <mat-option value="Business">Business</mat-option>
              <mat-option value="Analytic">Analytic</mat-option>
              <mat-option value="Info">Info</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Available</mat-label>
            <mat-select [(ngModel)]="quickAddNewDemoAvailable">
              <mat-option value="Y">Y</mat-option>
              <mat-option value="N">N</mat-option>
              <mat-option value="P">P</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Short Description</mat-label>
            <input matInput [(ngModel)]="quickAddNewDemoShortDescription" />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button mat-stroked-button type="button" (click)="closeModal()">Cancel</button>
      <button mat-flat-button color="primary" type="button" *ngIf="activeModal === 'quick-add'" (click)="saveQuickAdd()" [disabled]="isActionBusy(quickAddActionKey())">
        <mat-spinner *ngIf="isActionBusy(quickAddActionKey())" diameter="16" class="btn-spinner"></mat-spinner>
        <span *ngIf="!isActionBusy(quickAddActionKey())">{{ quickAddMode === 'new' ? 'Create Demo & Add File' : 'Add File' }}</span>
      </button>
    </div>
  </div>
</div>
